import { render, staticRenderFns } from "./CulturaList.vue?vue&type=template&id=c0648800&scoped=true"
import script from "./CulturaList.vue?vue&type=script&lang=js"
export * from "./CulturaList.vue?vue&type=script&lang=js"
import style0 from "./CulturaList.vue?vue&type=style&index=0&id=c0648800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0648800",
  null
  
)

export default component.exports